import { getColorVariables } from './ui/resolver';
import { ColorsProps } from '../common/themes/theme';

type extractColorsProps = {
  colors?: ColorsProps;
  withThemeColors?: boolean;
};

export const extractThemeColors = (props: extractColorsProps): string[] => {
  const { colors, withThemeColors = true } = props;
  if (!colors || !withThemeColors) return [];

  const resolvedColors = getColorVariables(colors, false);
  return Object.keys(resolvedColors).map(key => `var(${key})`);
};
